import { Input } from "@maxhub/max-ui"
import { useState } from "react"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const InputExample = {
    title: 'Input',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'mode',
            label: 'mode',
            type: 'enum',
            tsType: ['"default"', '"contrast"'],
            default: "default",
            options: ['default', 'contrast']
        },
        {
            name: 'iconAfter',
            label: 'iconAfter',
            type: 'boolean',
            tsType: 'ReactNode',
            default: false
        },
        {
            name: 'iconBefore',
            label: 'iconBefore',
            type: 'boolean',
            tsType: 'ReactNode',
            default: true
        },
        {
            name: 'disabled',
            label: 'disabled',
            type: 'boolean',
            tsType: 'boolean',
            default: false
        },
        {
            name: 'size',
            label: 'size',
            type: 'enum',
            tsType: ['"large"', '"medium"'],
            default: 'large',
            options: ['large', 'medium'],
        },
        {
            name: 'placeholder',
            label: 'placeholder',
            type: 'text',
            tsType: 'string',
            default: "Placeholder",
        },
    ],

    Preview({ props }){
        const [value, setValue] = useState()

        const inputProps = {
            mode: props.mode,
            disabled: props.disabled,
            size: props.size,
            placeholder: props.placeholder || undefined,
            iconAfter: props.iconAfter ? <PlaceholderIcon/> : undefined,
            iconBefore: props.iconBefore ? <PlaceholderIcon/> : undefined,
            value,
            onChange: (event) => {
                setValue(event.target.value)
            },
        }
        return <Input {...inputProps}/>
    },

    getCode(){
        return `<Input
  defaultValue=""
  iconBefore={<PlaceholderIcon />}
  mode="default"
  placeholder="Placeholder"
/>`
    }

}